export enum APIEntityType {
  USER_ID = 'USER_ID',
}
